<template>
  <div class="p-3">
    <div class="row">
      <div class="col-2"></div>
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="numbers">
          <div class="row">
            <div class="col-6">
              <p
                class="mb-0 text-sm text-secondary text-capitalize font-weight-bold opacity-7 d-flex justify-content-start">
                {{ props.title }}
              </p>
            </div>
            <div class="col-6">
              <p
                class="mb-0 text-sm text-secondary text-capitalize font-weight-bold opacity-7 d-flex justify-content-end">
                <countTo class="segment-primary-color" :start-val="0" :end-val="props.progress" :duration="2000">
                </countTo>
                <span class="segment-primary-color">% concluído</span>
              </p>
            </div>
          </div>
          <div class="">
            <argon-progress color="segment-primary-color" :percentage="props.progress" />
          </div>
        </div>
      </div>
      <div class="col-2"></div>
    </div>
  </div>
</template>

<script setup>
import ArgonProgress from "@/components/ArgonProgress.vue";
import countTo from "vue-count-to/src";

const props = defineProps({
  progress: {
    type: Number,
    default: 0,
  },
  title: {
    type: String,
    default: "",
  }
});
</script>
